module.exports = __webpack_public_path__ + "static/webroll-0eb10c5d16ceac4422cec3b00ab3f0ad.mp4";